export const contactObjOne = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "About the author",
  headline: "Hi, I am Anjali.",
  description:
    "I love all things tech. The areas I am skilled in are Software Engineering, Machine Learning, Data Modelling and Cloud Solutioning. I love learning new skills and building things.",
  buttonLabel: "",
  imgStart: "",
  img: "./images/me.JPG",
  alt: "image goes here.",
  hasLink: false,
  link: "",
};

export const contactObjTwo = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "How to reach me",
  headline: "My preferred channel of contact is LinkedIn.",
  description:
    "I am planning to be more active on GitHub, Hackerrank, and Kaggle. In the meantime, don't be shy and reach out to me on LinkedIn.",
  buttonLabel: "My LinkedIn",
  imgStart: "",
  img: "./images/celebration.svg",
  alt: "image goes here.",
  hasLink: true,
  link: "//www.linkedin.com/in/anjali-manoj-ahuja/",
  isPurple: true,
};

export const contactObjThree = {
  lightBg: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "what are people saying #1",
  headline: "Nah mate, she's a Jet. ",
  description: "- unnamed Friend & Colleague",
  buttonLabel: "",
  imgStart: "",
  img: "./images/business-man-working.svg",
  alt: "image goes here.",
  hasLink: false,
  link: "",
  isPurple: false,
};

export const contactObjFour = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "what are people saying #2",
  headline: "Very Employable and Dateable. ",
  description: "- my Mom",
  buttonLabel: "",
  imgStart: "start",
  img: "./images/business-woman-working.svg",
  alt: "image goes here.",
  hasLink: false,
  link: "",
  isPurple: true,
};
